import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { GlobalProvider } from './providers/global-provider';
import { useAdaptiveDensity } from './hooks/use-adaptive-density';
import { useDomCodeNavigation } from './hooks/use-dom-code-navigation';
import '../styles/fonts.css';
import '../styles/theme.css';

console.log('DEBUG: App.tsx loaded');

/**
 * AQL Vision Standalone Entrypoint
 * This version of the App component bootstraps the AQL Vision specific router.
 */
export default function App() {
  console.log('DEBUG: App component rendering');
  useAdaptiveDensity();
  useDomCodeNavigation();

  return (
    <GlobalProvider>
      <div className="aql-vision-standalone">
        <RouterProvider router={router} />
      </div>
    </GlobalProvider>
  );
}
